import React, { useMemo } from 'react';
import usePermission from '../../../utils/hooks/permissionHooks';
import {
  SecondaryNavContainer,
  SecondaryNavLinks,
} from '../../../components/SecondaryNav';
import { scheduleNavLinks } from './utils';

const ScheduleNav = () => {
  const { checkIsPermitted } = usePermission();

  const links = useMemo(
    () =>
      scheduleNavLinks.map((link) => {
        const isPermitted = link?.permissionKeys
          ? checkIsPermitted({
              requiredPermissionKeys: link.permissionKeys,
            })
          : true;
        return {
          ...link,
          isPermitted,
        };
      }),
    [checkIsPermitted],
  );

  return (
    <SecondaryNavContainer heading="Schedule">
      <SecondaryNavLinks links={links} />
    </SecondaryNavContainer>
  );
};

export default ScheduleNav;
